"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectangleUtils = void 0;
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var number_utils_1 = require("../../formatter/utils/number-utils");
var RectangleUtils = (function () {
    function RectangleUtils() {
    }
    RectangleUtils.getNonCollapsedIntersection = function (objA, objB) {
        var inters = rectangle_1.Rectangle.getIntersection(objA, objB);
        return inters && !this.isCollapsed(inters) ? inters : null;
    };
    RectangleUtils.isCollapsed = function (rect) {
        return rect.isCollapsed() || number_utils_1.NumberUtils.areClose(rect.x, rect.right) || number_utils_1.NumberUtils.areClose(rect.y, rect.bottom);
    };
    return RectangleUtils;
}());
exports.RectangleUtils = RectangleUtils;
